import BugsnagPerformance from '@bugsnag/browser-performance'

export default defineNuxtPlugin((nuxtApp) => {
    const { bugsnagApiKey } = useRuntimeConfig().public;

    if(bugsnagApiKey){
        BugsnagPerformance.start({ apiKey: bugsnagApiKey as string })
    }
});